import { useTranslation } from 'react-i18next';
import {
    useAppSelector,
    useTheme,
    Skeleton,
    Typography,
} from '../../../../base';
import { reportsSelectors } from '../../../../actions';
import { StyledConversionCard } from '../StageConversionRates/StageConversionRates.styles';

const OverallFunnelConversion = () => {
    const { t } = useTranslation();
    const theme = useTheme();
    const funnelData = useAppSelector(reportsSelectors.getFunnelData);
    const isLoading = useAppSelector(reportsSelectors.getIsLoadingFunnel);

    if (isLoading) {
        return (
            <Skeleton
                variant="rectangular"
                width="100%"
                height={250}
                sx={{ borderRadius: 1 }}
            />
        );
    }

    const { percentage, hires, total } = (() => {
        if (!funnelData)
            return { percentage: '0', hires: 0, total: 0 };

        // For job view, use summary.hired; otherwise search in funnel array
        const hiredCount =
            funnelData.view === 'job' && funnelData.summary
                ? funnelData.summary.hired
                : funnelData.funnel.find((item) => item.label === 'Hired')
                      ?.count ?? 0;
        const totalCount = funnelData.total;

        return {
            percentage:
                totalCount > 0
                    ? ((hiredCount / totalCount) * 100).toFixed(1)
                    : '0',
            hires: hiredCount,
            total: totalCount,
        };
    })();

    return (
        <StyledConversionCard>
            <Typography variant="h6">
                {t('reportsPage.overallFunnelConversion.title')}
            </Typography>
            <Typography
                variant="body1"
                color={theme.palette.grey[500]}
            >
                {t('reportsPage.overallFunnelConversion.subtitle')}
            </Typography>
            <Typography
                variant="h3"
                sx={{
                    color: theme.palette.text.secondary,
                    fontWeight: 600,
                    marginTop: theme.spacing(2),
                }}
            >
                {percentage}%
            </Typography>
            <Typography
                variant="body2"
                color={theme.palette.text.secondary}
            >
                {t('reportsPage.overallFunnelConversion.hiresOutOf', {
                    hires: hires.toLocaleString(),
                    total: total.toLocaleString(),
                })}
            </Typography>
        </StyledConversionCard>
    );
};

export default OverallFunnelConversion;
